<template>
  <div id="osList">
    <!-- <div class="row col-12 d-flex align-items-center justify-content-between">
        <h5>
          <i class="fas fa-tools"></i>
          Ordens de serviço em aberto
        </h5>
        <div class="col"> -->
    <filtros-armazem @update-filters="updateFilters" @updateLayout="methodValidaLayout">
      <template slot="pagination"><os-pagination></os-pagination></template>
    </filtros-armazem>
    <!-- </div>
      </div> -->

    <div class="col-12 text-center pt-3 animated fadeout" v-if="items == 'loading'">
      <span style="font-size: 2rem">
        <i class="fas fa-pulse fa-spinner mr-3"></i>{{this.$t('Carregando')}}...
      </span>
    </div>
    <div class="row" v-if="items && items !== 'loading'">
      <div class="col-12 mb-3 text-center">
        <span v-if="items == 'loading'">
          {{this.$t('Carregando')}}...
        </span>
        <span v-if="items !== 'loading' && items.total > 0">
          {{ $t('Exibindo resultado') }}
          <span class="badge badge-light" style="font-size:18px">{{ items.from }} <span
              class="font-weight-normal">a</span>
            {{ items.to }}</span>
          {{ $t('de') }}
          <span class="badge badge-warning" style="font-size:18px">{{
            items.total
            }}</span>
        </span>
        <span class="w-100 text-center" v-if="items !== 'loading' && !items.total">
          {{ $t('Nenhum resultado encontrado') }}.

        </span>
      </div>

      <div class="col-12 row" v-if="validaLayout == 'Cards'">
        <os-card class="col-xl-4 col-lg-4 col-md-6" v-for="(os, index) in items.data" :key="index" :os="os"></os-card>
      </div>

      <div v-if="validaLayout == 'Colunas'" id="osList" class="container-fluid">
        <div class="d-flex flex-row overflow-auto" style="white-space: nowrap; height: calc(100vh - 255px);">
          <!-- Coluna 1 -->
          <div class="col-lg-4 col-md-6">
            <h5 class="text-center text-bold text-red">IMEDIATA {{ criticidade1.length }}</h5>
            <os-card class="col-xl-12 col-lg-12 col-md-6" v-for="(os, index) in criticidade1" :key="index"
              :os="os"></os-card>
          </div>

          <div class="col-lg-4 col-md-6">
            <h5 class="text-center text-bold text-orange">EMERGENCIAL {{ criticidade5.length }}</h5>
            <os-card class="col-xl-12 col-lg-12 col-md-6" v-for="(os, index) in criticidade5" :key="index"
              :os="os"></os-card>
          </div>

          <!-- Coluna 2 -->
          <div class="col-lg-4 col-md-6">
            <h5 class="text-center  text-bold text-warning">ALTA {{ criticidade2.length }}</h5>
            <os-card class="col-xl-12 col-lg-12 col-md-6" v-for="(os, index) in criticidade2" :key="index"
              :os="os"></os-card>
          </div>

          <!-- Coluna 3 -->
          <div class="col-lg-4 col-md-6">
            <h5 class="text-center text-bold text-green">MÉDIA {{ criticidade3.length }}</h5>
            <os-card class="col-xl-12 col-lg-12 col-md-6" v-for="(os, index) in criticidade3" :key="index"
              :os="os"></os-card>
          </div>

          <div class="col-lg-4 col-md-6">
            <h5 class="text-center text-bold text-primary">LEVE {{ criticidade4.length }}</h5>
            <os-card class="col-xl-12 col-lg-12 col-md-6" v-for="(os, index) in criticidade4" :key="index"
              :os="os"></os-card>
          </div>

          <!-- Coluna 3 -->
          <!-- <div class="col-lg-4 col-md-6">
            <h5 class="text-center text-danger">Outras Criticidades</h5>
            <div class="card mb-3" v-for="(os, index) in outrasCriticidades" :key="index">
              <div class="card-body">
                <p>{{ os.titulo }}</p>
              </div>
            </div>
          </div> -->
        </div>
      </div>


      <div class="col-12 d-flex justify-content-center mt-2 mb-5">
        <os-pagination position="bottom"></os-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import OsCard from '@/components/OsCard'
  import FiltrosArmazem from '@/components/FiltrosArmazem'
  import OsPagination from '@/components/OsPagination'
  
  export default {
    components: {
      OsCard,
      FiltrosArmazem,
      OsPagination
    },
  
    created() {
      let filters = {
        placa: '',
        tipo: '',
        de: '',
        ate: '',
        codigo: ''
      }
      try{
        const filtrosAplicados = JSON.parse(localStorage.filtrosArmazem);

        if(filtrosAplicados.checkSaveFilter){
          filters = filtrosAplicados
        }
      } catch (e) {
        console.log(e)
      }

      this.$store.commit('os/setFilters', { filters: filters })
      this.$emit('update-filters', { filters: filters })
  
    },
  
    data() {
      return {
        showFiltros: false,
        recarregarFiltro: true,
        validaLayout: 'Cards'
      }
    },
  
    computed: {
      items() {
        if (!this.$store.getters['os/page'](this.paginacao.currentPage)) {
          this.fetchItemsFromApi()
        }
  
        return this.$store.getters['os/page'](this.paginacao.currentPage)
  
      },
      paginacao() {
        return this.$store.getters['os/pagination']
      },
          // Emergencial
      criticidade1() {
        return this.items.data.filter(os => os.nr_seq_criticidade === 1);
      },
      //Alta
      criticidade2() {
        return this.items.data.filter(os => os.nr_seq_criticidade === 2);
      },
      //Media
      criticidade3() {
        return this.items.data.filter(os => os.nr_seq_criticidade === 3);
      },
      //Leve
      criticidade4() {
        return this.items.data.filter(os => os.nr_seq_criticidade === 4);
      },
      //Emergencial
      criticidade5() {
        return this.items.data.filter(os => os.nr_seq_criticidade === 5);
      },

      outrasCriticidades() {
        return this.items.data.filter(os => os.nr_seq_criticidade !== 1 && os.nr_seq_criticidade !== 2);
      },
    },
  
    mounted() {
      this.$store.dispatch('os/fetchFromApiArmazem', {})
      this.methodValidaLayout()
    },
  
    methods: {
      methodValidaLayout() {
        try {
          let layout = JSON.parse(localStorage.getItem('layoutTerminal')) || { tipo_layout: "Cards" };
          this.validaLayout = layout.tipo_layout
          // return layout.tipo_layout
        } catch (e){
          this.validaLayout = "Cards"
          console.log(e)
        }
      },
      refreshFilter() {
        this.recarregarFiltro = false
      },
  
      updateFilters(newFilters) {
        this.$store.dispatch('os/reset')
        this.fetchItemsFromApi()
      },
  
      fetchItemsFromApi() {
        this.$store.dispatch('os/fetchFromApiArmazem')
      }
    }
  }
  </script>

<style lang="scss">
  .icon--custom {
    top: 50px;
  }
</style>